module.exports = __webpack_public_path__ + "img/award-card-bg.c07826c1.png";